import {textStyleKeeper} from './style-keepers/text-style';
import {FlowlineStyleKeeper} from './style-keepers/flowline-style';
import {Injectable} from '@angular/core';
import {ServerStyleCollection, ServerStyleObject} from './styles.model';
import {StyleKeeper} from './style-keepers/style-keeper.model';
import {StickerStyleKeeper} from './style-keepers/sticker-style';
import {TerminatorStyleKeeper} from './style-keepers/terminator-style';
import {ConnectorStyleKeeper} from './style-keepers/connector-style';
import {ActivityStyleKeeper} from './style-keepers/activity-style';
import {ImageStyleKeeper} from './style-keepers/image-style';
import {SwimlaneStyleKeeper} from './style-keepers/swimlane-style';
import {BehaviorSubject, Observable} from 'rxjs';
import {get} from 'lodash';
import {DiagramTypeConfigService} from '../../core/services/diagram-type-config.service';

@Injectable()
export class StylesService {
  isSFA = false;
  primaryStyles = <ServerStyleCollection>{};
  private activityStyleBH: BehaviorSubject<any> = new BehaviorSubject(null);
  public activityStyle$: Observable<any> = this.activityStyleBH.asObservable();

  constructor(private diagramTypeConfigService: DiagramTypeConfigService) {}

  setPrimary(styles: ServerStyleCollection | any): void {
    this.primaryStyles = styles;
    this.activityStyleBH.next(get(styles, 'activity', null));
  }

  getPrimary(shape): ServerStyleObject {
    switch (shape) {
      case 'text':
        return this.primaryStyles.text ? this.primaryStyles.text.normal : {};

      case 'flowline':
        return this.primaryStyles.flowline ? this.primaryStyles.flowline : {};

      case 'terminator':
        return this.primaryStyles.terminator ? this.primaryStyles.terminator : {};

      case 'connector':
        return this.primaryStyles.connector ? this.primaryStyles.connector : {};

      case 'activity':
        return this.primaryStyles.activity ? this.primaryStyles.activity : {};

      case 'swimlane':
        return this.primaryStyles.swimline ? this.primaryStyles.swimline : {};

      case 'resource':
        return this.primaryStyles.resource ? this.primaryStyles.resource : {};
    }

    return {};
  }

  flowline(flowlineObj?: any): StyleKeeper {
    const custom = flowlineObj && flowlineObj.customStyle && flowlineObj.style;
    const styles = custom ? flowlineObj.style : this.getPrimary('flowline');

    return new FlowlineStyleKeeper(styles, flowlineObj);
  }

  text(textObj: any): StyleKeeper {
    const custom = textObj && textObj.customStyle && textObj.style;
    const styles = custom ? textObj.style : this.getPrimary('text');

    return textStyleKeeper(styles, textObj);
  }

  sticker(stickerObj: any): StyleKeeper {
    return new StickerStyleKeeper(stickerObj);
  }

  terminator(terminatorObj: any): StyleKeeper {
    const custom = terminatorObj && terminatorObj.customStyle && terminatorObj.styleObject;
    const styles = custom ? terminatorObj.styleObject : this.getPrimary('terminator');

    return new TerminatorStyleKeeper(styles, terminatorObj);
  }

  connector(connectorObj: any): StyleKeeper {
    const custom = connectorObj && connectorObj.customStyle && connectorObj.styleObject;
    const styles = custom ? connectorObj.styleObject : this.getPrimary('connector');

    return new ConnectorStyleKeeper(styles, connectorObj);
  }

  activity(actObj: any): ActivityStyleKeeper {
    const custom = actObj && actObj.customStyle && actObj.style;
    const primaryStyle = this.getPrimary('activity');
    const styles = custom ? actObj.style : primaryStyle;
    const resourceStyle = custom ? actObj.style.resourcesStyle : this.getPrimary('resource');
    const infoStyle = primaryStyle.infoStyle;

    return new ActivityStyleKeeper(
      actObj,
      styles,
      this.diagramTypeConfigService,
      resourceStyle,
      infoStyle
    );
  }

  image(imageObj: any): ImageStyleKeeper {
    return new ImageStyleKeeper(imageObj);
  }

  swimlane(swimlaneObj: any): SwimlaneStyleKeeper {
    const styles = (swimlaneObj && swimlaneObj.style) || this.getPrimary('swimlane');

    return new SwimlaneStyleKeeper(swimlaneObj, styles);
  }
}
